export const normalizeEmailInput = (value) =>
  String(value || "").trim().toLowerCase();

const GMAIL_DOMAINS = new Set(["gmail.com", "googlemail.com"]);

const YAHOO_DOMAINS = new Set([
  "yahoo.com",
  "yahoo.in",
  "yahoo.co.in",
  "ymail.com",
]);

const OUTLOOK_DOMAINS = new Set([
  "hotmail.com",
  "hotmail.co.in",
  "outlook.com",
  "outlook.in",
  "live.com",
  "live.in",
  "msn.com",
]);

const validateProviderDomain = (domain) => {
  if (domain.startsWith("gmail") && !GMAIL_DOMAINS.has(domain)) {
    return "Please enter a valid Gmail address (e.g. name@gmail.com)";
  }

  if (domain.startsWith("yahoo") && !YAHOO_DOMAINS.has(domain)) {
    return "Please enter a valid Yahoo email address";
  }

  const outlookPrefix = domain.split(".")[0];
  if (
    ["hotmail", "outlook", "live", "msn"].includes(outlookPrefix) &&
    !OUTLOOK_DOMAINS.has(domain)
  ) {
    return "Please enter a valid Outlook/Hotmail email address";
  }

  return "";
};

export const validateEmail = (value) => {
  const raw = String(value || "");

  if (!raw.trim()) {
    return "Email is required";
  }

  if (/\s/.test(raw)) {
    return "Email cannot contain spaces";
  }

  const email = normalizeEmailInput(raw);

  if ((email.match(/@/g) || []).length !== 1) {
    return "Please enter a valid email address";
  }

  if (email.includes("..")) {
    return "Please enter a valid email address";
  }

  const [localPart, domainPart] = email.split("@");

  if (!localPart || !domainPart) {
    return "Please enter a valid email address";
  }

  if (localPart.length < 3 || localPart.length > 64) {
    return "Email username must be at least 3 characters";
  }

  if (!/^[a-z0-9](?:[a-z0-9._%+-]*[a-z0-9])?$/.test(localPart)) {
    return "Please enter a valid email address";
  }

  if (
    !/^[a-z0-9](?:[a-z0-9-]*[a-z0-9])?(?:\.[a-z0-9](?:[a-z0-9-]*[a-z0-9])?)+$/.test(
      domainPart
    )
  ) {
    return "Please enter a valid email address (e.g. name@gmail.com)";
  }

  const tld = domainPart.split(".").pop();

  if (!tld || tld.length < 2 || !/^[a-z]+$/.test(tld)) {
    return "Please enter a valid email address";
  }

  const providerError = validateProviderDomain(domainPart);
  if (providerError) {
    return providerError;
  }

  return "";
};
